export const loanApplication = {
  loan_identification_agreement: [
    "I do hereby give my consent to JSC Procredit Bank (hereinafter the Bank) to process my personal data, including photo/video material and biometric data (facial features) obtained during the identification process, for providing identification/verification and banking services in compliance with the law, since it is necessary for accurate identification, and to go through the online identification.",
    "I understand that the above data may become available to third-party service providers (Identomat Inc.), whose software the Bank uses for identification/verification.",
    "The Bank shall ensure to safeguard my information from accidental or illegal destruction, modification, disclosure, extraction, illegal use in any other form and accidental or illegal loss.",
    'I have read and agree to the <a href="https://www.procreditbank.ge/en/banking-services-conditions-1">Banking Service Conditions.</a>',
  ],
  loan_revenue_service_consent:
    "Consent to data verification in the LEPL Revenue Service database",
  loan_credit_bureau_consent:
    "Consent to data verification in the Credit Information database",
  loan_remittance_income_consent:
    "Consent to Handle Income from Remittance Transactions",
  loan_future_offers_consent:
    "Consent to data processing for further offers",
};
